module.exports = __webpack_public_path__ + "media/audio6.81beaa6b.mp3";